"use client";

import { useEffect, useState } from "react";

const EVENT = {
  title: "SA vs NZ",
  subtitle: "LIVE HUGE LED Streaming from DHL Stadium",
  venue: "SK Walmers Rugby Club, Green Point Track, Cape Town",
  date: "2026-08-29T17:00:00+02:00",
  displayDate: "29 August 2026",
  type: "Public Fundraising Event",
  capacity: "Up to 6,500 patrons (limited allowed pax)",
};

function useCountdown(targetDate: string) {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    function calc() {
      const diff = new Date(targetDate).getTime() - Date.now();
      if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      return {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      };
    }
    setTimeLeft(calc());
    const id = setInterval(() => setTimeLeft(calc()), 1000);
    return () => clearInterval(id);
  }, [targetDate]);

  return timeLeft;
}

export default function UpcomingEvents() {
  const { days, hours, minutes, seconds } = useCountdown(EVENT.date);

  return (
    <section id="events" className="py-20 bg-springbok-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-springbok-gold/20 text-springbok-gold text-sm font-semibold rounded-full mb-4">
            📅 Upcoming Events
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4">
            Don&apos;t Miss the Action
          </h2>
        </div>

        <div className="relative rounded-2xl border border-springbok-gold/30 bg-gradient-to-br from-springbok-dark to-neutral-900 overflow-hidden shadow-2xl shadow-springbok-gold/10">
          {/* Accent bar */}
          <div className="h-1.5 bg-gradient-to-r from-springbok-gold via-yellow-400 to-springbok-gold" />

          <div className="p-8 sm:p-12">
            {/* Title */}
            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-8">
              <div className="lg:w-2/3">
                <p className="text-springbok-gold font-semibold text-sm uppercase tracking-wider mb-2">
                  {EVENT.type}
                </p>
                <h3 className="text-3xl sm:text-4xl font-extrabold text-white mb-2">
                  🏉 {EVENT.title}
                </h3>
                <p className="text-xl text-neutral-300 mb-6">
                  {EVENT.subtitle}
                </p>

                <div className="space-y-3 text-neutral-300">
                  <div className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-springbok-gold mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span>{EVENT.venue}</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-springbok-gold mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <span>{EVENT.displayDate}</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-springbok-gold mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span>{EVENT.capacity}</span>
                  </div>
                </div>
              </div>

              {/* Countdown */}
              <div className="lg:w-1/3">
                <p className="text-center text-sm font-semibold text-springbok-gold uppercase tracking-wider mb-4">
                  Countdown to Kick-off
                </p>
                <div className="grid grid-cols-4 gap-3">
                  {[
                    { value: days, label: "Days" },
                    { value: hours, label: "Hours" },
                    { value: minutes, label: "Mins" },
                    { value: seconds, label: "Secs" },
                  ].map((unit) => (
                    <div
                      key={unit.label}
                      className="flex flex-col items-center bg-black/40 border border-springbok-gold/20 rounded-xl py-4 px-2"
                    >
                      <span className="text-3xl sm:text-4xl font-extrabold text-springbok-gold tabular-nums">
                        {String(unit.value).padStart(2, "0")}
                      </span>
                      <span className="text-xs text-neutral-400 mt-1 uppercase tracking-wider">
                        {unit.label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
